import React from 'react'
import Question from './Question'
import Collapsed from './Collapsed'

interface IProps {
  names: string[]
  responses: any
  corrections?: any
}

const Questions = (props: IProps) => {
  const { names, responses, corrections } = props

  return 'questionNumber' in responses ? (
    <Question
      key={`${names.join('-')}-${responses.questionNumber}`}
      nameKeys={names}
      response={responses}
      correction={corrections}
    />
  ) : (
    <Collapsed names={names} responses={responses} corrections={corrections} />
  )
}

export default Questions
